const APIURl = 'http://localhost:30000'
module.exports = {
    APIURl: APIURl,
}
